import { Box, Typography } from "@mui/material";
import useColors from "../../../../../../api/hooks/useColors";
import IntegrationImage from "../../../../integrations/components/IntegrationImage";
import { dataStoreHasTags } from "./checkRowsDataStore";

const TagsDataStoreView = ({ entityData }) => {
  const colors = useColors();
  return dataStoreHasTags(entityData) ? (
    <Box>
      {entityData?.tags?.length > 0 && (
        <Box>
          <Box display={"flex"} flexDirection={"column"} gap={1}>
            {entityData?.tags.map((tag) => (
              <Box display={"flex"} flexDirection={"column"} gap={0.5}>
                <Box display={"flex"} gap={1}>
                  <IntegrationImage
                    name={"aws"}
                    width={"24px"}
                    newLogo={true}
                  />
                  <Typography variant="overline" fontWeight={500}>
                    Key
                  </Typography>
                </Box>

                <Typography
                  ml={4}
                  variant="caption"
                  sx={{ color: colors.text_secondary }}
                >
                  {tag.key}
                </Typography>

                <Typography variant="overline" fontWeight={500} ml={3.5}>
                  Value
                </Typography>
                <Typography
                  ml={4}
                  variant="caption"
                  sx={{ color: colors.text_secondary, wordBreak: "break-all" }}
                >
                  {tag.value}
                </Typography>
              </Box>
            ))}
          </Box>
        </Box>
      )}
      {entityData?.azure_sql_database_data?.resource_tags?.length > 0 && (
        <Box>
          <Box display={"flex"} flexDirection={"column"} gap={1}>
            {entityData.azure_sql_database_data.resource_tags.map(
              (tag, index) => (
                <Box
                  key={index}
                  display={"flex"}
                  flexDirection={"column"}
                  gap={0.5}
                >
                  <Box display={"flex"} gap={1}>
                    <IntegrationImage
                      name={"azure"}
                      width={"24px"}
                      newLogo={true}
                    />
                    <Typography variant="overline">Key</Typography>
                  </Box>

                  <Typography
                    ml={4}
                    variant="caption"
                    sx={{ color: colors.text_secondary }}
                  >
                    {tag.key}
                  </Typography>

                  <Typography variant="overline" ml={3.5}>
                    Value
                  </Typography>
                  <Typography
                    ml={4}
                    variant="caption"
                    sx={{ color: colors.text_secondary }}
                  >
                    {tag.value}
                  </Typography>
                </Box>
              )
            )}
          </Box>
        </Box>
      )}
      {entityData?.azure_storage_account_data?.resource_tags?.length > 0 && (
        <Box>
          <Box display={"flex"} flexDirection={"column"} gap={1}>
            {entityData.azure_storage_account_data.resource_tags.map(
              (tag, index) => (
                <Box
                  key={index}
                  display={"flex"}
                  flexDirection={"column"}
                  gap={0.5}
                >
                  <Box display={"flex"} gap={1}>
                    <IntegrationImage
                      name={"azure"}
                      width={"24px"}
                      newLogo={true}
                    />
                    <Typography variant="overline">Key</Typography>
                  </Box>

                  <Typography
                    ml={4}
                    variant="caption"
                    sx={{ color: colors.text_secondary }}
                  >
                    {tag.key}
                  </Typography>

                  <Typography variant="overline" ml={3.5}>
                    Value
                  </Typography>
                  <Typography
                    ml={4}
                    variant="caption"
                    sx={{ color: colors.text_secondary }}
                  >
                    {tag.value}
                  </Typography>
                </Box>
              )
            )}
          </Box>
        </Box>
      )}
      {entityData?.mongo_atlas_data?.project_tags?.length > 0 && (
        <Box>
          {entityData?.mongo_atlas_data?.project_tags.map((tag, index) => (
            <Box
              key={index}
              display={"flex"}
              flexDirection={"column"}
              gap={0.5}
            >
              <Box display={"flex"} gap={1}>
                <IntegrationImage
                  name={"mongoatlas"}
                  width={"24px"}
                  newLogo={true}
                />
                <Typography variant="overline">Key</Typography>
              </Box>

              <Typography
                ml={4}
                variant="caption"
                sx={{ color: colors.text_secondary }}
              >
                {tag.key}
              </Typography>

              <Typography variant="overline" ml={3.5}>
                Value
              </Typography>
              <Typography
                ml={4}
                variant="caption"
                sx={{ color: colors.text_secondary }}
              >
                {tag.value}
              </Typography>
            </Box>
          ))}
        </Box>
      )}
      {entityData?.azure_blob_container_data?.resource_tags?.length > 0 && (
        <Box>
          <Box display={"flex"} flexDirection={"column"} gap={1}>
            {entityData.azure_blob_container_data.resource_tags.map(
              (tag, index) => (
                <Box
                  key={index}
                  display={"flex"}
                  flexDirection={"column"}
                  gap={0.5}
                >
                  <Box display={"flex"} gap={1}>
                    <IntegrationImage
                      name={"azure"}
                      width={"24px"}
                      newLogo={true}
                    />
                    <Typography variant="overline">Key</Typography>
                  </Box>

                  <Typography
                    ml={4}
                    variant="caption"
                    sx={{ color: colors.text_secondary }}
                  >
                    {tag.key}
                  </Typography>

                  <Typography variant="overline" ml={3.5}>
                    Value
                  </Typography>
                  <Typography
                    ml={4}
                    variant="caption"
                    sx={{ color: colors.text_secondary }}
                  >
                    {tag.value}
                  </Typography>
                </Box>
              )
            )}
          </Box>
        </Box>
      )}
      {entityData?.azure_file_share_data?.resource_tags?.length > 0 && (
        <Box>
          <Box display={"flex"} flexDirection={"column"} gap={1}>
            {entityData.azure_file_share_data.resource_tags.map(
              (tag, index) => (
                <Box
                  key={index}
                  display={"flex"}
                  flexDirection={"column"}
                  gap={0.5}
                >
                  <Box display={"flex"} gap={1}>
                    <IntegrationImage
                      name={"azure"}
                      width={"24px"}
                      newLogo={true}
                    />
                    <Typography variant="overline">Key</Typography>
                  </Box>

                  <Typography
                    ml={4}
                    variant="caption"
                    sx={{ color: colors.text_secondary }}
                  >
                    {tag.key}
                  </Typography>

                  <Typography variant="overline" ml={3.5}>
                    Value
                  </Typography>
                  <Typography
                    ml={4}
                    variant="caption"
                    sx={{ color: colors.text_secondary }}
                  >
                    {tag.value}
                  </Typography>
                </Box>
              )
            )}
          </Box>
        </Box>
      )}
      {entityData?.azure_queue_data?.resource_tags?.length > 0 && (
        <Box>
          <Box display={"flex"} flexDirection={"column"} gap={1}>
            {entityData.azure_queue_data.resource_tags.map((tag, index) => (
              <Box
                key={index}
                display={"flex"}
                flexDirection={"column"}
                gap={0.5}
              >
                <Box display={"flex"} gap={1}>
                  <IntegrationImage
                    name={"azure"}
                    width={"24px"}
                    newLogo={true}
                  />
                  <Typography variant="overline">Key</Typography>
                </Box>

                <Typography
                  ml={4}
                  variant="caption"
                  sx={{ color: colors.text_secondary }}
                >
                  {tag.key}
                </Typography>

                <Typography variant="overline" ml={3.5}>
                  Value
                </Typography>
                <Typography
                  ml={4}
                  variant="caption"
                  sx={{ color: colors.text_secondary }}
                >
                  {tag.value}
                </Typography>
              </Box>
            ))}
          </Box>
        </Box>
      )}
      {entityData?.azure_table_data?.resource_tags?.length > 0 && (
        <Box>
          <Box display={"flex"} flexDirection={"column"} gap={1}>
            {entityData.azure_table_data.resource_tags.map((tag, index) => (
              <Box
                key={index}
                display={"flex"}
                flexDirection={"column"}
                gap={0.5}
              >
                <Box display={"flex"} gap={1}>
                  <IntegrationImage
                    name={"azure"}
                    width={"24px"}
                    newLogo={true}
                  />
                  <Typography variant="overline">Key</Typography>
                </Box>

                <Typography
                  ml={4}
                  variant="caption"
                  sx={{ color: colors.text_secondary }}
                >
                  {tag.key}
                </Typography>

                <Typography variant="overline" ml={3.5}>
                  Value
                </Typography>
                <Typography
                  ml={4}
                  variant="caption"
                  sx={{ color: colors.text_secondary }}
                >
                  {tag.value}
                </Typography>
              </Box>
            ))}
          </Box>
        </Box>
      )}
      {entityData?.starburst_snowflake_catalog_data?.tags && (
        <Box>
          <Typography variant="overline">Tags</Typography>
          <Box display={"flex"} flexDirection={"column"} gap={0.5}>
            <Typography
              ml={2}
              variant="caption"
              sx={{ color: colors.text_secondary }}
            >
              {entityData?.starburst_snowflake_catalog_data?.tags.join(", ")}
            </Typography>
          </Box>
        </Box>
      )}
      {entityData?.sentra_data?.tags?.length > 0 &&
        (entityData?.aws_data?.tags?.length <= 0 ||
          entityData?.aws_data?.tags === undefined) && (
          <Box>
            <Box display={"flex"} flexDirection={"column"} gap={1}>
              {entityData.sentra_data.tags.map((tag, index) => (
                <Box
                  key={index}
                  display={"flex"}
                  flexDirection={"column"}
                  gap={0.5}
                >
                  <Box display={"flex"} gap={1}>
                    <IntegrationImage
                      name={"sentra"}
                      width={"24px"}
                      newLogo={true}
                    />
                    <Typography variant="overline">Key</Typography>
                  </Box>

                  <Typography
                    ml={4}
                    variant="caption"
                    sx={{ color: colors.text_secondary }}
                  >
                    {tag.key}
                  </Typography>

                  <Typography variant="overline" ml={3.5}>
                    Value
                  </Typography>
                  <Typography
                    ml={4}
                    variant="caption"
                    sx={{ color: colors.text_secondary }}
                  >
                    {tag.value}
                  </Typography>
                </Box>
              ))}
            </Box>
          </Box>
        )}
    </Box>
  ) : null;
};

export default TagsDataStoreView;
